import request2 from '@/utils/request2'

// 根据机构ID查询预警配置
export function getPreRechargeConfig(params, config = {}) {
  return request2({
    url: '/cloud/edata-bill/tenant/early/warning/config/getByTenantId',
    method: 'get',
    params,
    ...config
  })
}

// 创建或更新预警配置
export function createOrUpdatePreRechargeConfig(data, config = {}) {
  return request2({
    url: '/cloud/edata-bill/tenant/early/warning/config/saveOrUpdate',
    method: 'post',
    data,
    ...config
  })
}

// 删除预警配置
export function delPreRechargeConfig(data) {
  return request2({
    url: '/cloud/edata-bill/tenant/early/warning/config/delById',
    method: 'delete',
    data
  })
}

// 根据订单号查询订单
export function getOrderByOrderNo(params) {
  return request2({
    url: '/cloud/edata-bill/tenant/recharge/order/detail',
    method: 'get',
    params
  })
}

// 线下充值
export function rechargeOffline(data) {
  return request2({
    url: '/cloud/edata-bill/tenant/recharge/order/offline/recharge',
    method: 'post',
    data
  })
}

// 线上充值
export function rechargeOnline(data) {
  return request2({
    url: '/cloud/edata-bill/tenant/recharge/order/online/recharge',
    method: 'post',
    data
  })
}

// 分页查询充值订单
export function getRechargeOrderPage(params) {
  return request2({
    url: '/cloud/edata-bill/tenant/recharge/order/page',
    method: 'get',
    params
  })
}

// 线上充值预下单
export function preOrderRechargeOnline(data, config = {}) {
  return request2({
    url: '/cloud/edata-bill/tenant/recharge/order/pre/recharge',
    method: 'post',
    data,
    ...config
  })
}

// 查询预充值获课软件对公收款账号配置信息
export function getOrgCorpPaymentAccountConfig(params) {
  return request2({
    url: '/cloud/pay/org/corp/payment/account/config/getByTenantId',
    method: 'get',
    params
  })
}

// 查询机构账户余额
export function getTenantAccountBalance(params) {
  return request2({
    url: '/cloud/edata-bill/tenant/recharge/account/balance/getTenantBalance',
    method: 'get',
    params
  })
}

// 分页查询机构充值账户余额
export function getTenantAccountBalancePage(params) {
  return request2({
    url: '/cloud/edata-bill/tenant/recharge/account/balance/page',
    method: 'get',
    params
  })
}

// 线下退款
export function offlineRefund(data) {
  return request2({
    url: '/cloud/edata-bill/tenant/account/balance/refund/record/refunds',
    method: 'post',
    data
  })
}

// 分页查询机构产品预充值开关历史记录配置
export function getHistoryConfigPage(params) {
  return request2({
    url: '/cloud/edata-bill/tenant/product/item/history/config/page',
    method: 'get',
    params
  })
}

// 保存历史配置
export function saveHistoryConfig(data) {
  return request2({
    url: '/cloud/edata-bill/tenant/product/item/history/config/save',
    method: 'post',
    data
  })
}

// 删除历史配置
export function delHistoryConfig(params) {
  return request2({
    url: '/cloud/edata-bill/tenant/product/item/history/config/del',
    method: 'delete',
    params
  })
}

// 机构预充值历史记录详情
export function getHistoryConfigDetail(params) {
  return request2({
    url: '/cloud/edata-bill/tenant/product/item/history/config/detail',
    method: 'get',
    params
  })
}

// 产品收费下拉列表查询
export function getProductChargesList(params) {
  return request2({
    url: '/cloud/edata-bill/product/charges/product/list',
    method: 'get',
    params
  })
}

// 产品收费明细项下拉列表查询
export function getProductChargesItemList(params) {
  return request2({
    url: '/cloud/edata-bill/product/charges/product/item/list',
    method: 'get',
    params
  })
}

// 产品收费明细项详情
export function getProductChargesItemDetail(params) {
  return request2({
    url: '/cloud/edata-bill/product/charges/item/detail',
    method: 'get',
    params
  })
}

// 新增AI外呼坐席
export function addAIOutboundAgent(data) {
  return request2({
    url: '/cloud/edata-message/aicall-agent/add',
    method: 'post',
    data
  })
}

// 根据机构ID查询AI外呼座席列表
export function getAIOutboundAgentList(params) {
  return request2({
    url: '/cloud/edata-message/aicall-agent/list',
    method: 'get',
    params
  })
}

// 启用-禁用AI外呼座席
export function enableOrDisableAIOutboundAgent(data) {
  return request2({
    url: '/cloud/edata-message/aicall-agent/toggle-status',
    method: 'put',
    data
  })
}
// 查询机构账户余额
export function getAccountBalance(params) {
  return request2({
    url: '/cloud/edata-bill/fegin/recharge/account/balance/getAccountBalance',
    method: 'get',
    params
  })
}

// 当前登录机构的余额可用天数预警弹窗详情
export function getBalanceDaysWarningDetail() {
  return request2({
    url: '/cloud/edata-bill/tenant/recharge/account/balance/warningDetail',
    method: 'get'
  })
}

// 更新平台统一的账单预警天数与提醒频率
export function getGlobalWarningConfig() {
  return request2({
    url: '/cloud/edata-bill/tenant/recharge/account/balance/warningConfig',
    method: 'get'
  })
}

export function updateGlobalWarningConfig(data) {
  return request2({
    url: '/cloud/edata-bill/tenant/recharge/account/balance/updateWarningConfig',
    method: 'post',
    data
  })
}
